// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD-u0wE6pQCUFxlcIGpt2H9sfLqaa4EZWM",
  authDomain: "traveling-agency-9cf35.firebaseapp.com",
  projectId: "traveling-agency-9cf35",
  storageBucket: "traveling-agency-9cf35.appspot.com",
  messagingSenderId: "830711649477",
  appId: "1:830711649477:web:0a9c28ecaedd8843994cac",
  measurementId: "G-09YHZXZK2X",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
